var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIndianicShortLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "26px",
    viewBox: "0 0 27 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "indianic-short-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "indianic-short-logo",
    transform: "translate(0.979933, 0.000000)",
    fill: "#252B33",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12.8354028 C0,5.74857872 5.6900643,0 12.7135079,0 C14.1444874,0 15.3045255,1.16800714 15.3045255,2.60881696 C15.3045255,4.04962678 14.1444874,5.21763391 12.7135079,5.21763391 C8.5559575,5.21763391 5.1820354,8.62625211 5.1820354,12.8354028 C5.1820354,17.0445536 8.5559575,20.4531718 12.7135079,20.4531718 C16.8710582,20.4531718 20.2449803,17.0445536 20.2449803,12.8354028 C20.2449803,11.394593 21.4050185,10.2265859 22.8359979,10.2265859 C24.2669779,10.2265859 25.4270159,11.394593 25.4270159,12.8354028 C25.4270159,19.922227 19.7369514,25.6708057 12.7135079,25.6708057 C5.6900643,25.6708057 0,19.922227 0,12.8354028 Z M12.7135079,18.0817525 C9.8455222,18.0817525 7.5205605,15.7328817 7.5205605,12.8354028 C7.5205605,9.93792395 9.8455222,7.58905321 12.7135079,7.58905321 C15.5814935,7.58905321 17.9064552,9.93792395 17.9064552,12.8354028 C17.9064552,15.7328817 15.5814935,18.0817525 12.7135079,18.0817525 Z",
    id: "INIC-LWS-[-20--1714--4921--70]"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndianicShortLogo);
export default __webpack_public_path__ + "static/media/indianic-short-logo.64df188792ff96dfdbe742d14202874a.svg";
export { ForwardRef as ReactComponent };